import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { promotionKeys } from "./query-keys";

export interface RenameCampaignVars {
  id: string;
  body: components["schemas"]["UpdateCampaignRequest"];
}

export function useRenameCampaign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, body }: RenameCampaignVars) => {
      const { data, error } = await apiClient.PATCH("/v1/campaigns/{id}", {
        params: { path: { id } },
        body,
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, { id }) => {
      void qc.invalidateQueries({ queryKey: promotionKeys.campaign(id) });
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
